import React, { useState, useEffect } from 'react';
import blogService from '../services/blogService';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const data = await blogService.getAllPosts();
        setPosts(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch posts');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) return <div className="blog-container">Loading posts...</div>;
  if (error) return <div className="blog-container">{error}</div>;

  return (
    <div className="blog-container">
      <h1>Blog Posts</h1>
      <p>Here you'll find all our latest articles and posts.</p>
      <div className="blog-posts">
        {posts.length === 0 ? (
          <p>No posts available at the moment.</p>
        ) : (
          posts.map(post => (
            <div key={post._id} className="blog-post-card">
              <h2>{post.title}</h2>
              <p className="post-meta">
                <span>By {post.author}</span>
                <span>{new Date(post.createdAt).toLocaleDateString()}</span>
              </p>
              <p>{post.excerpt}</p>
              <a href={`/blog/${post._id}`} className="read-more">Read more</a>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Blog; 